import React from "react";

import TooltipBasic from "@src/sharedComponents/Tooltip/TooltipBasic";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./TaxStatusLabel.module.css";

const labelText =
  "Taxable model portfolios are meant to be applied to taxable accounts. Tax-advantaged model portfolios are meant for tax-exempt and tax-deferred accounts.";

const TaxStatusLabel = () => {
  return (
    <div className={styles.flexRow}>
      <Text variant="body" color={"textSubtle"}>
        Tax Status
      </Text>

      <TooltipBasic className={styles.tooltip} text={labelText} />
    </div>
  );
};

export default TaxStatusLabel;
